"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utiliser sur des composants spécifiques pour les transformateurs
 *
 */
exports.default = {
    props: ["sourceType", "sourceTarget", "defaultValue"],
    data: function data() {
        var _this = this;
        var model = this.$root.$data;
        var getSourceValue = function getSourceValue(model) {
            return _this.sourceType ? model.dataStore[_this.sourceType.toLowerCase() + "_" + _this.sourceTarget] || "" : _this.defaultValue || "";
        };
        var datas = getSourceValue(model);
        return {
            selected: datas,
            value: datas === '' ? null : this.multiple !== undefined && this.multiple !== 'false' ? datas.split(',') : datas
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Transformateur/Mixins/SourceValueTransfo.ts
// module id = 131
// module chunks = 0